import { render, staticRenderFns } from "./AddseedlingInspection.vue?vue&type=template&id=36146a67&scoped=true&"
import script from "./AddseedlingInspection.vue?vue&type=script&lang=ts&"
export * from "./AddseedlingInspection.vue?vue&type=script&lang=ts&"
import style0 from "./AddseedlingInspection.vue?vue&type=style&index=0&id=36146a67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36146a67",
  null
  
)

export default component.exports